export default __webpack_public_path__ + "static/media/ic_import.7602256d.svg";